// extracted by mini-css-extract-plugin
export default {"date":"_3nZej","eventList":"_1mssc","dateText":"_2Kn-f","eventDetails":"_7K336","dateWithChevron":"NwGwc","dateChevron":"_2i9RY","close":"_3yJNG"};